import { MutationTree } from 'vuex'
import { WorkFileTrackingState } from './types'
import { idGenerator } from '@/services'

export const mutations: MutationTree<WorkFileTrackingState> = {
  RESET(state) {
    state.requestId = idGenerator.getNewWebReference()
  }
}
